var app = angular.module("leonardo");

var OnDemandFiltersSubcategories = function(
  $scope,
  $controller,
  OnDemandCategoryService,
  ClientInstanceService
) {

  $controller('FiltersBaseController', { $scope: $scope });

  const clientInstanceOptions = ClientInstanceService.getlist({ essential: true }).then(function (response) {
    return response.map(function (clientInstance) {
      return {
        id: clientInstance.id,
        name: `${clientInstance.name} (id: ${clientInstance.id})`
      };
    });
  });

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'client_instances',
          name: 'Client Instance',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Client Instances',
          condition: $scope.authDataService.isAdmin(),
          options: clientInstanceOptions,
          conflicts: ['account_reports', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: false,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1 && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.accounts,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
      ]
    },
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      service: OnDemandCategoryService,
      conflicts: ['subcategory']
    },
    {
      id: 'search',
      name: 'Keyword Search',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Keyword Search',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];
  $scope.filterService.showFilters(['search'], []);
};

app.controller('OnDemandFiltersSubcategories', [
  '$scope',
  '$controller',
  'OnDemandCategoryService',
  'ClientInstanceService',
  OnDemandFiltersSubcategories
]);
